import React from 'react';

const TailwindConfigInjection: React.FC = () => (
  <script dangerouslySetInnerHTML={{
    __html: `
      tailwind.config = {
        theme: {
          screens: {
            'xs': '360px',
            'md': '768px', 
            'lg': '960px',
            'xl': '1280px',
            '2xl': '1920px',
          },
          extend: {
            colors: {
              brand: {
                primary: '#F5300D',
                hover: '#1c1c1c',
                secondary: '#1c1c1c',
                dark: '#130C0F',
                white: '#f0f0f0',
                bg: '#f0f0f0',
                surface: '#FFFFFF',
                telegram: '#24A1DE',
              }
            },
            fontFamily: {
              sans: ['Inter', 'sans-serif'],
              display: ['UraBumBumSP', 'cursive'],
            },
            borderRadius: {
              '4xl': '2.5rem',
              '5xl': '3rem',
            },
            boxShadow: {
              'soft': '0 10px 30px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(255, 255, 255, 0.8) inset',
              'glow': '0 0 25px rgba(255, 77, 109, 0.4)',
              'float': '0 10px 40px -10px rgba(0, 0, 0, 0.15)',
            },
            backgroundImage: {
              'gradient-hero': 'linear-gradient(to right, rgba(255,255,255,0.9) 10%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%)',
              'gradient-hero-mobile': 'linear-gradient(to top, rgba(255,255,255,1) 5%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 100%)',
            }
          }
        }
      }
    `
  }} />
);

export default TailwindConfigInjection;